"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_tracking_1 = require("react-tracking");
var sanitized_render_1 = require("../../components/sanitized_render");
var elog = require("../../elog");
var tracker_1 = require("../../tracker");
var lightbox_image_1 = require("../../components/lightbox_image");
var url_helpers_1 = require("../../url_helpers");
var COMPONENT_NAME = 'ImageGallery';
var ImageGallery = /** @class */ (function (_super) {
    tslib_1.__extends(ImageGallery, _super);
    function ImageGallery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageGallery.prototype.getImageURLs = function () {
        return this.props.images.map(function (i) { return url_helpers_1.imageUploadURL(i.image); });
    };
    ImageGallery.prototype.getImageAlts = function () {
        return this.props.images.map(function (i) { return i.caption; });
    };
    ImageGallery.prototype.render = function () {
        try {
            return (React.createElement("section", { className: "image-gallery", id: this.props.jumplinkSlug },
                (!!this.props.titleHtml || !!this.props.title) &&
                    React.createElement(sanitized_render_1.default, { html: this.props.titleHtml || this.props.title, className: "image-gallery__title", htmlTag: "h3" }),
                React.createElement("div", { className: "image-gallery__inner" },
                    React.createElement(lightbox_image_1.default, { thumbURLs: this.getImageURLs(), fullsizeURLs: this.getImageURLs(), imageURLs: this.getImageURLs(), imageAlts: this.getImageAlts(), showAltsAsCaptions: true, withControls: true }))));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    ImageGallery = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: COMPONENT_NAME,
                type: tracker_1.MARKETING_TYPE,
                eventType: tracker_1.VIEW,
                context: {
                    layoutSection: props.layoutSection,
                    pagePosition: props.pagePosition,
                },
            };
        }, { dispatchOnMount: true })
    ], ImageGallery);
    return ImageGallery;
}(React.Component));
exports.default = ImageGallery;
//# sourceMappingURL=image_gallery.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/image_gallery.js
// module id = Hwwh
// module chunks = 0 2 6 20